// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__dKAfT","icon__detail":"styles_icon__detail__cQXCn","icon__detail_block":"styles_icon__detail_block__7Vgp7","actionButton":"styles_actionButton__CTIf8"};